import React from 'react';

function ButtonAngleRight({ action }) {
    return (
        <button
            type="button"
            className="btn btn-lg waves-effect waves-light btn-outline-info border-0"
            onClick={action}
        >
            <span className="fa fa-angle-right"></span>
        </button>
    );
}

export default ButtonAngleRight;
